import Context from 'contexts/Theme/ThemeContext';
import Provider from 'contexts/Theme/ThemeProvider';

export default {
  Consumer: Context.Consumer,
  Context,
  Provider,
};
